import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppUserState } from '../shared/store/user/user.store';
import { EUserRole } from '../../../../regocheckshared/enums/euserrole';

export const AdminGuard: CanActivateFn = (route, state) => {
  const userStore = inject(Store<AppUserState>);
  const router = inject(Router);
  var IsLoggedIn:boolean = false;
  var IsAdmin:boolean = false;
  userStore.select((state) => state.loggedInUser.user)
    .subscribe(user => {      
      IsLoggedIn = user.token!=''
      IsAdmin = user.role == EUserRole.superuser
    });

  if(IsLoggedIn && IsAdmin)
  {
    return true;
  }
  else{
    router.navigate(['/']);
    return false;
  } 
};